const user = {
  namespaced: true,
  state: {},
  mutations: {
    setUserData(state, userData) {
      Object.assign(state, userData);
    }
  },
  actions: {
    updateData(context) {
      context.rootState.client.getConfig(function (err, _, data) {
        if (err) {
          return;
        }

        context.commit("setUserData", data.user_data);
      });
    }
  },
};

export default user;
